export const version = '5.1.4';
export const buildTime = 'Thu Nov 27 2025 13:46:31 GMT+0100 (Central European Standard Time)';
export const sourceUrl = 'https://github.com/UUDigitalHumanitieslab/gretel/tree/364c454f3a97a357752a36ebf78124ebdf46cbd8';
